import { Koi } from '@ksyos/koi';
import type { ISchemaContainer } from '../ISchemaContainer';

export interface IOsasPatientQuestionnaireCustomControlData {
    doneBetter: string | null;
    enoughInformation: number | null;
    explanationClear: number | null;
    explanationUnderstandable: number | null;
    feltHelped: number | null;
    opportunityToAskQuestions: number | null;
    repeatDigitalExamination: number | null;
    satisfiedWith: string | null;
    scoreFreeText: string | null;
    scoreKsyosSleep: number | null;
    sleepExaminationFreeText: string | null;
    videoConsultFreeText: string | null;
}

export interface IOsasPatientQuestionnaireAddValidated {
    customControlData: IOsasPatientQuestionnaireCustomControlData;
}

export const osasQuestionnaireStep1Schema = {
    schema: Koi.object().keys({
        enoughInformation: Koi.number().min(0).max(10),
        explanationClear: Koi.number().min(0).max(10),
        sleepExaminationFreeText: Koi.string().allow(null),
    }),
};

export const osasQuestionnaireStep2Schema = {
    schema: Koi.object().keys({
        explanationUnderstandable: Koi.number().min(0).max(10),
        feltHelped: Koi.number().min(0).max(10),
        opportunityToAskQuestions: Koi.number().min(0).max(10),
        videoConsultFreeText: Koi.string().allow(null),
    }),
};

export const osasQuestionnaireStep3Schema = {
    schema: Koi.object().keys({
        repeatDigitalExamination: Koi.number().min(0).max(10),
        scoreFreeText: Koi.string().allow(null),
        scoreKsyosSleep: Koi.number().min(0).max(10),
    }),
};

export const osasQuestionnaireStep4Schema = {
    schema: Koi.object().keys({
        doneBetter: Koi.string().allow(null),
        satisfiedWith: Koi.string().allow(null),
    }),
};

export const osasPatientQuestionnaireCustomControlDataSchema: ISchemaContainer<IOsasPatientQuestionnaireAddValidated> =
    {
        schema: Koi.object()
            .concat(osasQuestionnaireStep1Schema.schema)
            .concat(osasQuestionnaireStep2Schema.schema)
            .concat(osasQuestionnaireStep3Schema.schema)
            .concat(osasQuestionnaireStep4Schema.schema)
            .options({ presence: 'required' }),
    };
